<!-- @format -->
<template>
    <div class="columns">
        <div class="column is-8">
            <field name="data.comment" :errors="errors">
                <label class="label">Comment</label>
                <div class="control">
                    <textarea v-model="comment" class="textarea" placeholder="your comments" required />
                </div>
            </field>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        errors: {
            type: [Array, Object],
            default: () => []
        },
        formData: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            comment: null
        };
    },

    watch: {
        comment() {
            this.updateFormData();
        },
        formData() {
            this.comment = this.formData && this.formData.comment ? this.formData.comment : null;
        },
        deep: true
    },

    mounted() {
        this.updateFormData(); // Init
    },

    methods: {
        /**
         * Update form data for parent
         */
        updateFormData() {
            this.$emit('update:formData', {
                comment: this.comment
            });
        }
    }
};
</script>
